import { useSearchParams } from "react-router-dom";

interface BlogTag {
  id: string;
  name: string;
  slug: string;
}

interface BlogTagFilterProps {
  tags: BlogTag[];
}

export function BlogTagFilter({ tags }: BlogTagFilterProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTag = searchParams.get('tag');

  const handleTagClick = (tagSlug: string) => {
    const newParams = new URLSearchParams(searchParams);
    if (activeTag === tagSlug) {
      newParams.delete('tag');
    } else {
      newParams.set('tag', tagSlug);
    }
    // Reset search when changing tag
    setSearchParams(newParams);
  };

  const handleClear = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('tag');
    setSearchParams(newParams);
  };

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2" dir="rtl">
      <button
        onClick={handleClear}
        className={`text-sm px-3 py-1.5 border transition-all duration-200 ${
          !activeTag
            ? 'bg-primary text-primary-foreground border-primary'
            : 'bg-transparent text-foreground border-border hover:border-primary/50'
        }`}
      >
        הכל
      </button>
      {tags.map(tag => (
        <button
          key={tag.id}
          onClick={() => handleTagClick(tag.slug)}
          className={`text-sm px-3 py-1.5 border transition-all duration-200 ${
            activeTag === tag.slug
              ? 'bg-primary text-primary-foreground border-primary'
              : 'bg-transparent text-foreground border-border hover:border-primary/50'
          }`}
        >
          {tag.name}
        </button>
      ))}
    </div>
  );
}
